import React from "react";
import { SectionDescriptionCardComponent } from "../../../components/section-desc-card/section-description-card.component";
import styled from "styled-components";
import AboutUsImage1 from "../../../assets/about-us-image1.svg";
import AboutUsImage2 from "../../../assets/about-us-image2.svg";
import AboutUsImage3 from "../../../assets/about-us-image3.svg";
import BackgroundImage from "../../../assets/bg.png";
import { useTranslation } from "react-i18next";

const AboutUsContainer = styled.div.attrs({
  id: "about-us",
})`

  background: url(${BackgroundImage}) center center fixed;
  -webkit-background-size: cover;



  width: 100%;
  background-color: rgba(29, 109, 193, 0.05);
  display: flex;
  justify-content: center;
  padding-top: 12px;
  padding-bottom: 100px;
`;
const AboutUsItems = styled.div`
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 480px) {
    max-width: 480px; 
  }
`;
const AboutUsItem = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 100px;
    @media (max-width: 1025px) {
    flex-direction: column;
    align-items: center;
    padding-top: 40px;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    padding-top: 40px;
  }

`;
const AboutUsItemImageWrapper = styled.figure`
  max-width: 550px;
  padding-left: 64px;
    @media (max-width: 1025px) {
    padding-left: 0;
  }
  @media (max-width: 480px) {
    width: 100%;
    max-width: 350px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 0;
  }
  @media (max-width: 380px) {
    max-width: 290px;
  }

`;
const AboutUsItemImage = styled.img`
  max-width: 100%;
  @media (max-width: 480px) {
  }
`;

export const AboutUs = ({ setModalOpen, setIsPartnerWithUs }) => {

  const { t } = useTranslation();

  return (
    <AboutUsContainer>
      <AboutUsItems>
        <AboutUsItem>
          <SectionDescriptionCardComponent
            label={t('about-us-label-1')}
            heading={t('about-us-heading-1')}
            para={{
              intro:
                t('about-us-para-1')
            }}
            buttons={1}
            option1GoTo="modal"
            setModalOpen={setModalOpen}
            button_primary={t('about-us-btn-1')}
          />
          <AboutUsItemImageWrapper>
            <AboutUsItemImage src={AboutUsImage1} alt="" />
          </AboutUsItemImageWrapper>
        </AboutUsItem>
        <AboutUsItem>
          <SectionDescriptionCardComponent
            label={t('about-us-label-2')}
            heading={t('about-us-heading-2')}
            para={{
              intro:
                t('about-us-para-2'),
              points: [
                t('about-us-bullet-pnt-1'),
                t('about-us-bullet-pnt-2'),
                t('about-us-bullet-pnt-3'),
              ],
            }}
            buttons={1}
            option1GoTo="modal"
            setModalOpen={setModalOpen}
            button_primary={t('about-us-btn-1')}
          />
          <AboutUsItemImageWrapper>
            <AboutUsItemImage src={AboutUsImage2} alt="" />
          </AboutUsItemImageWrapper>
        </AboutUsItem>
        <AboutUsItem>
          <SectionDescriptionCardComponent
            label={t('about-us-label-3')}
            heading={t('about-us-heading-3')}
            para={{
              intro:
                t('about-us-para-3')
            }}
            buttons={1}
            button_primary={t('about-us-btn-3')}
            setModalOpen={setModalOpen}
            option1GoTo="modal"
          />
          <AboutUsItemImageWrapper>
            <AboutUsItemImage src={AboutUsImage3} alt="" />
          </AboutUsItemImageWrapper>
        </AboutUsItem>
      </AboutUsItems>
    </AboutUsContainer>
  );
};
